import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { XCircle } from "react-feather";

import { palette, mediaMin } from "./styles";

const propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
};

export const Modal = (props) => {
  const { className, children, onModalClose } = props;

  return (
    <ModalWrapper className={className}>
      <ModalContainer>
        <ModalContent>
          {children}
          <ButtonWrapper>
            <XCircle
              color={palette.white}
              strokeWidth={1}
              size={30}
              onClick={() => onModalClose()}
              style={{ cursor: "pointer" }}
            />
          </ButtonWrapper>
        </ModalContent>
      </ModalContainer>
    </ModalWrapper>
  );
};

Modal.propTypes = propTypes;

const ModalWrapper = styled.div`
  will-change: visibility, opacity;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 999999999;
  overflow-y: auto;
  overflow-x: hidden;
  background-color: rgba(0, 0, 0, 0.7);
`;

// min-width set for medium screens - min 375px;
const ModalContainer = styled.div`
  max-width: 700px;
  width: 100%;
`;

const ModalContent = styled.div`
  will-change: transform, opacity;
  position: relative;
  background-clip: padding-box;
`;

const ButtonWrapper = styled.div`
  position: absolute;
  top: 0px;
  right: 0px;

  ${mediaMin.tablet_md`
    right: -15px;
    top: -15px;
  `}
`;
